import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainSectionContainer" }

import IntroducingSection from "./IntroducingSection.vue";
import BrandsList from "./BrandsList.vue";
import ServicesSection from "./ServicesSection.vue";
import FreeProposal from "./FreeProposal.vue";
import StudiesSwiper from "./StudiesSwiper.vue";
import WorkingProccesSection from "./WorkingProccesSection.vue";
import TeamsSection from "./TeamsSection.vue";
import TestimonialsSection from "./TestimonialsSection.vue";
import ContactSection from "./ContactSection.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IntroducingSection, { id: "about" }),
    _createVNode(BrandsList),
    _createVNode(ServicesSection),
    _createVNode(FreeProposal),
    _createVNode(StudiesSwiper),
    _createVNode(WorkingProccesSection),
    _createVNode(TeamsSection),
    _createVNode(TestimonialsSection),
    _createVNode(ContactSection)
  ]))
}
}

})